/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct,
    AssetsMelcoModelsGenericList1MelcoModelsSupplierProductFromJSON,
    AssetsMelcoModelsGenericList1MelcoModelsSupplierProductToJSON,
    AssetsMelcoModelsSupplierProduct,
    AssetsMelcoModelsSupplierProductFromJSON,
    AssetsMelcoModelsSupplierProductToJSON,
} from '../models';

export interface ThreadSupplierProductsApiAssetThreadSupplierProductsGetRequest {
    id: string;
    publishState?: string;
}

export interface ThreadSupplierProductsApiAssetThreadSupplierProductsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    name?: string;
    supplierId?: string;
    supplierName?: string;
    publishState?: string;
    supplierType?: string;
}

/**
 * 
 */
export class ThreadSupplierProductsApi extends runtime.BaseAPI {

    /**
     */
    async assetThreadSupplierProductsGetRaw(requestParameters: ThreadSupplierProductsApiAssetThreadSupplierProductsGetRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsSupplierProduct>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assetThreadSupplierProductsGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/threads/suppliers/products/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsSupplierProductFromJSON(jsonValue));
    }

    /**
     */
    async assetThreadSupplierProductsGet(requestParameters: ThreadSupplierProductsApiAssetThreadSupplierProductsGetRequest): Promise<AssetsMelcoModelsSupplierProduct> {
        const response = await this.assetThreadSupplierProductsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async assetThreadSupplierProductsSearchRaw(requestParameters: ThreadSupplierProductsApiAssetThreadSupplierProductsSearchRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.supplierName !== undefined) {
            queryParameters['supplier_name'] = requestParameters.supplierName;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.supplierType !== undefined) {
            queryParameters['supplier_type'] = requestParameters.supplierType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/threads/suppliers/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsGenericList1MelcoModelsSupplierProductFromJSON(jsonValue));
    }

    /**
     */
    async assetThreadSupplierProductsSearch(requestParameters: ThreadSupplierProductsApiAssetThreadSupplierProductsSearchRequest): Promise<AssetsMelcoModelsGenericList1MelcoModelsSupplierProduct> {
        const response = await this.assetThreadSupplierProductsSearchRaw(requestParameters);
        return await response.value();
    }

}
